/**
 * Tooltip Themes
 */
export default {
  LIGHT_BLUE: ' LIGHT-BLUE',
  REGULAR_SLATE: 'REGULAR-SLATE',
};
